<script setup lang="ts">
import {useUserStore} from '@store/user';
import {storeToRefs} from 'pinia';
import SectionAccount from '@sections/section-account.vue';
import PartSubscriptionInfo from '@parts/part-subscription-info.vue';
import ButtonPrimary from '@buttons/button-primary.vue';
import PartFooterNavigation from '@parts/part-footer-navigation.vue';

// import FormToggle from '@form/form-toggle.vue';
import {computed, /*ref, watch*/} from 'vue';
import {useI18n} from 'vue-i18n';
import {useSettings} from "@composables/settings";

const {t} = useI18n();
const userStore = useUserStore();
const {user} = storeToRefs(userStore);
const {goToBack} = useSettings();
// const autoDebit = ref<boolean>(!!user.value.subscription.auto_payment);

// watch(autoDebit, (value) => {
//   userStore.methods.update({
//     auto_payment: value
//   });
// })

const daysLeft = computed(() => {
  const today: Date = new Date();
  //today.setHours(0, 0, 0, 0);
  const target: Date = new Date(user.value.subscription.end);

  if (isNaN(target.getTime())) {
    throw new Error("Invalid date format. Use format 'YYYY-MM-DD'.");
  }

  const differenceInTime = target.getTime() - today.getTime();
  //const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
  const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);

  if (differenceInDays < 1) {
    return 0;
  }
  return Math.floor(differenceInDays);
});

const fields = computed(() => {
  const subscribeIcon = {
    active: {
      name: "clock",
      viewBox: "0 0 14 14"
    },
    expired: {
      name: "delete",
      viewBox: "0 0 14 14"
    },
  };
  return {
	icon: '/images/subscribe-icon.svg',
    title: t('accountSubscribe.title'),
    backButton: {
      title: t('common.buttons.back'),
      url: '/account'
    },
    settings: t('accountSubscribe.settings'),
    autoPay: t('accountSubscribe.autoPay'),
    box: {
      subscription: {
        icon: user.value.subscription.status !== 'expired' ? subscribeIcon.active : subscribeIcon.expired,
        title: t(`home.${user.value.subscription.status !== 'expired' ? 'active' : 'expired'}.subscription`)
      },
      title: t('accountSubscribe.subtitle', daysLeft.value),
      subtitle: t('accountSubscribe.description'),
      button: {
        url: "/payment",
        title: t('common.buttons.renew'),
      }
    }
  };
});

</script>

<template>
<main class="page page-subscribe">
	<transition
		appear
		name="fade"
		style="--animation-delay: 0s;"
	>
		<section-account
			:fields="fields"
		>
			<part-subscription-info
				:label="fields.box.subscription"
				:title="fields.box.title"
				:subtitle="fields.box.subtitle"
				:button="fields.box.button"
				class="page-subscribe__info"
			/>

			<!-- <form-toggle
				:label="fields.autoPay"
				:icon="{name: 'creditCard', viewBox: '0 0 24 24'}"
				v-model="autoDebit"
				name="autoDebit"
				panel
				class="page-subscribe__toggle"
			>
			</form-toggle> -->

			<part-footer-navigation
				v-if="fields?.backButton"
			>
				<button-primary
					pink
					@click.native="goToBack"
					class="page-subscribe__back"
				>
					{{ fields.backButton.title }}
				</button-primary>
			</part-footer-navigation>
		</section-account>
	</transition>
</main>
</template>

<style lang="scss">
.page-subscribe {
  &__info {
    margin-bottom: 1rem;
  }

  &__label {
    margin-bottom: 2.6rem;
  }

  &__back {
    width: 100%;
    margin-top: auto;
    height: 5.6rem;
  }

  &__container {
    margin-bottom: 2rem;
  }
  &__toggle {
	margin-bottom: 3.2rem;
	@include min-desktop {
		margin-bottom: 6.4rem;
	}
  }
}
</style>
